// packages/ui-kit/src/lib/useBodyScrollLock.ts
import { useEffect } from "react";

/**
 * Locks body scroll while a sheet/modal/drawer is open.
 * Restores the previous overflow value on close/unmount and is safe to nest
 * (the original value is captured per-mount). SSR-safe (guards on document).
 */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active || typeof document === "undefined") return;
    const { body } = document;
    const previousOverflow = body.style.overflow;
    body.style.overflow = "hidden";
    return () => {
      body.style.overflow = previousOverflow;
    };
  }, [active]);
}
